/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
/* eslint-disable comma-dangle */
/* eslint-disable object-curly-newline */
/* eslint-disable react/no-array-index-key */
import React from "react";

import bgImgLight from "../assets/images/ImgFooter/Fondo_Hom.svg";
import bgImgDark from "../assets/images/ImgFooter/Fondo_HomeD.svg";
import Galvin from "../assets/images/CaseStudy/CaseGalving.png";

const CaseGalvin1 = () => {
  return (
    <section className="pb-32">
      <div className="relative lg:max-w-[130rem] w-full rounded-3xl overflow-hidden shadow-[0_4px_8px_rgba(0,0,0,0.4]">
        <div className="absolute inset-0 z-0">
          <img
            src={bgImgLight}
            alt="Light Background"
            className="block dark:hidden w-full h-full object-cover opacity-70"
          />
          <img
            src={bgImgDark}
            alt="Dark Background"
            className="hidden dark:block w-full h-full object-cover opacity-70"
          />
          <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-b from-transparent to-white dark:to-theme-dark z-10" />
        </div>

        <div className="relative z-10 container mx-auto px-4 flex flex-col items-start justify-start gap-16 py-20 lg:flex-row lg:items-end lg:justify-between">
          <div className="flex w-full flex-col items-center justify-center gap-12">
            <div className="flex w-full max-w-[80rem] flex-col items-center justify-center gap-8">
              <div className="flex w-full flex-col gap-5 text-center">
                <h1 className="text-2xl lg:text-6xl leading-[1.2] font-semibold text-theme-blue dark:text-white">
                  Transforming Hospital
                  <br /> Water Safety
                </h1>
                <p className="text-base lg:text-lg leading-[1.4] font-light text-gray-400 lg:pb-12 ">
                  Galvin Engineering partners with Nube iO to deliver a scalable
                  IoT solution enhancing hospital water safety and compliance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-6">
        <div className="mx-auto w-full max-w-5xl lg:flex lg:gap-20 ">
          <div className="flex w-full max-w-[40rem] mx-auto flex-col gap-10">
            <div className="prose">
              <img
                src={Galvin}
                alt="Galvin Engineering"
                className="w-full object-contain rounded-lg mb-12"
              />
              <h4 className="text-base lg:text-xl font-bold text-theme-blue mb-4 pt-4 dark:text-theme-teal">
                Overview
              </h4>
              <p className="text-base lg:text-lg leading-[1.4] font-light text-gray-400">
                Hospitals and aged care facilities must carefully manage water
                safety to protect patients and staff. Galvin Engineering
                partnered with Nube iO to implement a connected IoT solution
                that provides continuous monitoring, greater visibility, and
                more efficient management of water safety risks.
              </p>
              <br />
              <h4 className="text-base lg:text-xl font-bold text-theme-blue mb-4 dark:text-theme-teal ">
                Challenge
              </h4>
              <h5 className="text-sm lg:text-lg font-bold text-theme-teal mb-4 dark:text-white ">
                Keeping patients’ safe starts with safe water.
              </h5>
              <p className="text-base lg:text-lg leading-[1.4] font-light text-gray-400">
                Effective management of water temperature and flow is critical
                in hospitals and aged care facilities to prevent bacterial
                growth and ensure regulatory compliance. Although Galvin
                Engineering’s thermostatic mixing valves are trusted throughout
                the healthcare sector, traditional monitoring methods presented
                significant operational challenges. These methods were manual,
                which delayed fault detection, increased administrative
                paperwork, and limited the ability to analyse trends or report
                on corrective actions. <br /> <br />
                To support its product roadmap, Galvin Engineering required a
                robust monitoring system for its thermostatic mixing valves. The
                solution needed to track temperature and flow continuously,
                identify where conditions in the water system were conducive to
                bacterial growth, and provide reliable reporting for facility
                managers on valve performance. Furthermore, to minimise
                facilities upfront capital costs, the system required a
                wireless, low-maintenance architecture capable of scaling
                seamlessly across multiple hospital sites.
              </p>
              <br />{" "}
              <h4 className="text-base lg:text-xl font-bold text-theme-blue mb-4 dark:text-theme-teal">
                Solution
              </h4>
              <h5 className="text-sm lg:text-lg font-bold text-theme-teal mb-4 dark:text-white ">
                A Smarter Way to Manage Critical Infrastructure
              </h5>
              <p className="text-base lg:text-lg leading-[1.4] font-light text-gray-400">
                The solution integrates Galvin Engineering’s thermostatic mixing
                valves with Nube iO’s IoT platform to automate the process of
                data collection for performance and compliance reporting.
                Wireless, low-maintenance LoRa® devices are fitted to each valve
                to gather temperature and flow data. This information is
                transmitted to the cloud and systematically compiled into
                periodic reports for facility managers.
              </p>
              <br />
              <h4 className="text-base lg:text-xl font-bold text-theme-blue mb-4 dark:text-theme-teal">
                Outcomes and Benefits
              </h4>
              <p className="text-base lg:text-lg leading-[1.4] font-light text-gray-400">
                The implementation of this automated solution delivered several
                key benefits for facility management
              </p>
              <br />
              <p className="text-base lg:text-lg leading-[1.4] font-light text-gray-400 ml-3">
                • Improved Efficiency and Accuracy: The system replaces time-
                consuming manual data logging, freeing up staff and eliminating
                the potential for human error in record-keeping. It creates a
                reliable and consistent digital audit trail for the entire valve
                network. <br /> <br /> • Enhanced Compliance and Confidence: The
                delivery of daily flow reports and monthly temperature profiles
                provides managers with regular, documented evidence of system
                performance. This simplifies compliance verification and offers
                confidence that assets were operating within parameters at the
                time of reporting. <br /> <br /> • Data-Driven Insights: The
                aggregation of historical data allows for long-term trend
                analysis. These insights can help identify systemic issues and
                inform future maintenance schedules or asset management
                strategies.
              </p>
              <br />
              <h4 className="text-base lg:text-xl font-bold text-theme-blue mb-4 dark:text-theme-teal ">
                Industry Endorsement
              </h4>
              <p className="text-base lg:text-lg leading-[1.4] font-light italic text-gray-400">
                “This collaboration delivers a water solution focused on
                automating performance monitoring. It provides our clients with
                efficient, accurate reporting that simplifies compliance, which
                in turn supports a healthier environment and allows them to
                focus their resources where they are needed most.”
              </p>
              <br />
              <p className="text-base lg:text-lg leading-[1.4] font-bold  text-gray-400">
                — Tim Galvin, Managing Director, Galvin Engineering
              </p>
              <br />{" "}
              <h4 className="text-base lg:text-xl font-bold text-theme-blue mb-4 dark:text-theme-teal">
                Conclusion
              </h4>
              <h5 className="text-sm lg:text-lg font-bold text-theme-teal mb-4 dark:text-white">
                A Partnership for Data-Driven Compliance
              </h5>
              <p className="text-base lg:text-lg leading-[1.4] font-light text-gray-400">
                This collaboration demonstrates how IoT technology can modernise
                the management and oversight of critical water infrastructure.
                By shifting from manual spot-checks to automated data
                collection, the solution enhances operational efficiency,
                simplifies regulatory compliance, and provides the valuable,
                documented data needed to uphold and verify water safety
                standards in demanding healthcare environments.
              </p>
            </div>
            <div className="flex items-end gap-4 mt-12">
              <a
                href="/case-studies/"
                className="text-base font-light text-gray-400 border-b border-gray-900 hover:text-theme-teal hover:border-theme-teal transition-all flex items-center gap-1"
              >
                View All
                <span className="text-theme-teal transition-transform group-hover:translate-x-1">
                  ←
                </span>
                <h4 className="text-xl font-bold text-theme-blue dark:text-white">
                  Case Studies
                </h4>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseGalvin1;
